import React from "react";

function XlsxIcon({ width = "20px", height = "20px", color = "#7030A0"}) {
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 91.607 91.607"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M59.245,0H12.392v91.607h66.824V27.17L55.478,10.778L59.245,0z M33.529,56.625l-2.015-4.029 c-0.826-1.552-1.356-2.707-1.983-3.996h-0.063c-0.464,1.287-1.026,2.443-1.721,3.996l-1.849,4.029h-5.746l6.44-11.263 l-6.21-10.998h5.781l1.947,4.062c0.662,1.354,1.157,2.445,1.686,3.7h0.064c0.53-1.42,0.959-2.412,1.521-3.7l1.881-4.062h5.747 l-6.275,10.867l6.607,11.394H33.529z M64.47,47.277c-3.698-1.287-6.11-3.334-6.11-6.571c0-3.799,3.173-6.706,8.424-6.706 c2.511,0,4.358,0.529,5.681,1.124l-1.123,4.062c-0.893-0.429-2.477-1.056-4.656-1.056s-3.236,0.99-3.236,2.146 c0,1.42,1.254,2.048,4.129,3.137c3.93,1.454,5.778,3.501,5.778,6.64c0,3.732-2.872,6.903-8.981,6.903 c-2.543,0-5.054-0.662-6.311-1.354l1.025-4.162c1.354,0.695,3.436,1.389,5.58,1.389c2.313,0,3.535-0.959,3.535-2.411 C68.202,49.027,67.147,48.234,64.47,47.277z M55.954,52.396v4.229H42.046V34.364h5.056v18.033H55.954z" />
            <polygon points="63.937,0 60.884,8.732 79.216,21.391 " />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default XlsxIcon;
